import React, { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router-dom'; // Import Link and useLocation
import { UserContext } from './auth/AuthWrapper';
import { SimpleThemeToggle } from './ThemeSwitch';

const Sidebar: React.FC = () => { // Remove SidebarProps and props
  const { user, logout } = useContext(UserContext);
  const location = useLocation(); // Initialize useLocation
  const [showUserMenu, setShowUserMenu] = useState(false);
  const menuItems = [
    { id: 'dashboard', icon: 'bi-house', label: 'Dashboard', path: '/dashboard' },
    { id: 'projects', icon: 'bi-layers', label: 'Vault', path: '/projects' },
    { id: 'documents', icon: 'bi-archive', label: 'Documents', path: '/documents' },
    { id: 'integrations', icon: 'bi-diagram-3', label: 'Integrations', path: '/integrations' },
    { id: 'chat', icon: 'bi-chat', label: 'Chat', path: '/chat' },
    { id: 'upload', icon: 'bi-book', label: 'Upload', path: '/upload' },
  ];

  const bottomItems = [
    { id: 'help', icon: 'bi-question-circle', label: 'Help', path: '/help' },
    { id: 'settings', icon: 'bi-gear', label: 'Settings', path: '/settings' },
  ];

  return (
    <div style={{
      background: 'var(--bg-color)',
      borderRight: '1px solid var(--border-color)',
      height: '100vh',
      width: '240px',
      display: 'flex',
      flexDirection: 'column',
      padding: '1rem 0'
    }}>
      {/* Logo/Brand */}
      <div style={{
        padding: '0 1.5rem',
        marginBottom: '2rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{
            width: '32px',
            height: '32px',
            background: 'var(--primary-color)',
            borderRadius: 'var(--radius-md)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '0.75rem'
          }}>
            <span style={{ color: 'white', fontWeight: 'bold', fontSize: '1.1rem' }}>H</span>
          </div>
          <span style={{
            color: 'var(--text-primary)',
            fontWeight: 600,
            fontSize: '1.2rem'
          }}>
            AnCore
          </span>
        </div>
        <SimpleThemeToggle />
      </div>

      {/* Main Navigation */}
      <nav style={{ flex: 1, padding: '0 1rem' }}>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {menuItems.map((item) => (
            <li key={item.id} style={{ marginBottom: '0.25rem' }}>
              <Link
                to={item.path}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  color: location.pathname === item.path ? 'var(--text-primary)' : 'var(--text-secondary)',
                  fontWeight: location.pathname === item.path ? 600 : 500,
                  padding: '0.75rem 1rem',
                  borderRadius: 'var(--radius-md)',
                  transition: 'all var(--transition-normal)',
                  background: location.pathname === item.path ? 'var(--surface-color)' : 'transparent',
                  border: 'none',
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  cursor: 'pointer',
                  textAlign: 'left'
                }}
                onMouseEnter={(e) => {
                  if (location.pathname !== item.path) {
                    e.currentTarget.style.background = 'var(--surface-color)';
                    e.currentTarget.style.color = 'var(--text-primary)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (location.pathname !== item.path) {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = 'var(--text-secondary)';
                  }
                }}
              >
                <i className={`bi ${item.icon}`} style={{
                  marginRight: '0.75rem',
                  fontSize: '1rem',
                  width: '16px'
                }}></i>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* Bottom Navigation */}
      <div style={{ padding: '0 1rem', borderTop: '1px solid var(--border-color)', paddingTop: '1rem' }}>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {bottomItems.map((item) => (
            <li key={item.id} style={{ marginBottom: '0.25rem' }}>
              <Link
                to={item.path}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  color: location.pathname === item.path ? 'var(--text-primary)' : 'var(--text-secondary)',
                  fontWeight: location.pathname === item.path ? 600 : 500,
                  padding: '0.75rem 1rem',
                  borderRadius: 'var(--radius-md)',
                  transition: 'all var(--transition-normal)',
                  background: location.pathname === item.path ? 'var(--surface-color)' : 'transparent',
                  border: 'none',
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  cursor: 'pointer',
                  textAlign: 'left'
                }}
                onMouseEnter={(e) => {
                  if (location.pathname !== item.path) {
                    e.currentTarget.style.background = 'var(--surface-color)';
                    e.currentTarget.style.color = 'var(--text-primary)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (location.pathname !== item.path) {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = 'var(--text-secondary)';
                  }
                }}
              >
                <i className={`bi ${item.icon}`} style={{
                  marginRight: '0.75rem',
                  fontSize: '1rem',
                  width: '16px'
                }}></i>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        
        {/* User Profile */}
        <div style={{ position: 'relative' }}>
          <button
            onClick={() => setShowUserMenu(!showUserMenu)}
            style={{
              width: '100%',
              marginTop: '1rem',
              padding: '0.75rem 1rem',
              background: 'var(--surface-color)',
              borderRadius: 'var(--radius-md)',
              display: 'flex',
              alignItems: 'center',
              border: 'none',
              cursor: 'pointer',
              transition: 'all var(--transition-normal)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'var(--card-color)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'var(--surface-color)';
            }}
          >
            <div style={{
              width: '32px',
              height: '32px',
              minWidth: '32px',
              minHeight: '32px',
              background: user?.full_name ? 'var(--primary-color)' : 'var(--danger-color)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '0.75rem',
              flexShrink: 0
            }}>
              <span style={{ color: 'white', fontWeight: 'bold', fontSize: '0.9rem' }}>
                {user?.full_name ? user.full_name.charAt(0).toUpperCase() :
                 user?.username ? user.username.charAt(0).toUpperCase() :
                 user?.email ? user.email.charAt(0).toUpperCase() : 'U'}
              </span>
            </div>
            <div style={{ flex: 1, textAlign: 'left' }}>
              <div style={{ color: 'var(--text-primary)', fontWeight: 500, fontSize: '0.85rem' }}>
                {user?.full_name || user?.username || user?.email || 'User'}
              </div>
              {user?.full_name && (
                <div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem' }}>
                  {user.email}
                </div>
              )}
            </div>
            <i className={`bi ${showUserMenu ? 'bi-chevron-up' : 'bi-chevron-down'}`}
               style={{ color: 'var(--text-secondary)', fontSize: '0.8rem' }}></i>
          </button>

          {/* User Dropdown Menu */}
          {showUserMenu && (
            <div style={{
              position: 'absolute',
              bottom: '100%',
              left: '0',
              right: '0',
              background: 'var(--bg-color)',
              border: '1px solid var(--border-color)',
              borderRadius: 'var(--radius-md)',
              boxShadow: 'var(--shadow-lg)',
              marginBottom: '0.5rem',
              zIndex: 1000,
              overflow: 'hidden'
            }}>
              <div style={{
                padding: '0.75rem 1rem',
                borderBottom: '1px solid var(--border-color)',
                background: 'var(--surface-color)'
              }}>
                <div style={{ color: 'var(--text-primary)', fontWeight: 600, fontSize: '0.85rem' }}>
                  {user?.full_name || user?.username || 'User'}
                </div>
                <div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem' }}>
                  {user?.email}
                </div>
                {user?.is_verified && (
                  <div style={{
                    color: 'var(--success-color)',
                    fontSize: '0.7rem',
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '0.25rem'
                  }}>
                    <i className="bi bi-check-circle-fill" style={{ marginRight: '0.25rem' }}></i>
                    Verified
                  </div>
                )}
              </div>
              
              <Link
                to="/settings" // Assuming /settings is the profile settings page
                onClick={() => setShowUserMenu(false)}
                style={{
                  width: '100%',
                  padding: '0.75rem 1rem',
                  background: 'none',
                  border: 'none',
                  textAlign: 'left',
                  cursor: 'pointer',
                  fontSize: '0.85rem',
                  color: 'var(--text-primary)',
                  transition: 'background var(--transition-normal)',
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none' // Remove underline from Link
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'var(--surface-color)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
              >
                <i className="bi bi-person" style={{ marginRight: '0.75rem', width: '16px' }}></i>
                Profile Settings
              </Link>

              <button
                onClick={() => {
                  setShowUserMenu(false);
                  logout();
                }}
                style={{
                  width: '100%',
                  padding: '0.75rem 1rem',
                  background: 'none',
                  border: 'none',
                  textAlign: 'left',
                  cursor: 'pointer',
                  fontSize: '0.85rem',
                  color: 'var(--danger-color)',
                  transition: 'background var(--transition-normal)',
                  display: 'flex',
                  alignItems: 'center',
                  borderTop: '1px solid var(--border-color)'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(239, 68, 68, 0.1)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
              >
                <i className="bi bi-box-arrow-right" style={{ marginRight: '0.75rem', width: '16px' }}></i>
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
